export const addMetrix = (requestData) => {
  return {
    ...allMetrix(requestData.leaseForm),
    ...requestData.leaseForm.applicationRequest
  }
}

const allMetrix = (data) => {
  let thrt_metrix_id
  if (typeof affTmSessionId !== 'undefined' && affTmSessionId.length) {
    thrt_metrix_id = affTmSessionId;
  }

  return {
      metrixSessionId: data.metrixSessionId,
      threatMetrixPayTomorrowSessionId: data.threatMetrixPayTomorrowSessionId,
      snapSessionId: data.snapSessionId,
      uownSessionId: data.uownSessionId,
      blackboxId: data.blackboxId,
      thrtMetrixId: thrt_metrix_id,
      koalafi_neuro_id: data.koalafiNeuroId,
  }
}
